import styled from 'styled-components';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import moment from 'moment';
import { IThemeInfo } from 'scheme/themeInfo';
import DoubleThemeBubble from 'components/DoubleThemeBubble';
import SingleThemeBubble from 'components/SingleThemeBubble';

interface IScrolledThemesProps {
  openedThemes: IThemeInfo[];
  beforeOpenedThemes: IThemeInfo[];
  now: moment.Moment;
  handleBeforeOpenedClick: () => void;
}

export default function ScrolledThemes({
  openedThemes,
  beforeOpenedThemes,
  now,
  handleBeforeOpenedClick,
}: IScrolledThemesProps) {
  return (
    <ScrolledThemesContainer>
      {openedThemes.map((themeInfo) =>
        themeInfo.themes.length > 1 ? (
          <>
            <DoubleThemeBubble
              isOpen={now.diff(themeInfo.date, 'milliseconds') > 0}
              themeInfo={themeInfo}
              handleBeforeOpenedClick={handleBeforeOpenedClick}
            />
          </>
        ) : (
          <>
            <SingleThemeBubble
              isOpen={now.diff(themeInfo.date, 'milliseconds') > 0}
              themeInfo={themeInfo}
              handleBeforeOpenedClick={handleBeforeOpenedClick}
            />
          </>
        ),
      )}
      {beforeOpenedThemes.map((themeInfo) =>
        themeInfo.themes.length > 1 ? (
          <>
            <DoubleThemeBubble
              isOpen={now.diff(themeInfo.date, 'milliseconds') > 0}
              themeInfo={themeInfo}
              handleBeforeOpenedClick={handleBeforeOpenedClick}
            />
          </>
        ) : (
          <>
            <SingleThemeBubble
              isOpen={now.diff(themeInfo.date, 'milliseconds') > 0}
              themeInfo={themeInfo}
              handleBeforeOpenedClick={handleBeforeOpenedClick}
            />
          </>
        ),
      )}
    </ScrolledThemesContainer>
  );
}

const ScrolledThemesContainer = styled.div`
  margin-top: 40px;
`;
